<template>
	<span class="data-table-sorting-icon">&nbsp;</span>
</template>

<script>
    export default {
		name: 'SortingIcon'
    };
</script>

<style>
	.data-table-sorting-icons .icon::before,
	.data-table-sorting-icons .icon::after {
		content: "" !important;
	}

	[data-sorting="asc"] .data-table-sorting-icons .icon.asc {
		background-image: url(./../../assets/images/arrow-down.png) !important;
	}

	[data-sorting="desc"] .data-table-sorting-icons .icon.desc {
		background-image: url(./../../assets/images/arrow-up.png) !important;
	}
</style>